import { Component } from 'preact';

// const getState = () => {
//   const state = localStorage.getItem('state');
//   try {
//     return JSON.parse(localStorage.getItem('state'));
//   } catch (e) {
//     console.error('getState', e);
//     return { raw: state };
//   }
// };

// const bugsnagList = [];
// let Bugsnag;
// const BugsnagFallback = {
//   notify: (...args) => bugsnagList.push(args),
// };

// if (
//   typeof window !== 'undefined' &&
//   process.env.BUGSNAG_KEY &&
//   !window.location.host.match('localhost')
// ) {
//   import('@bugsnag/js')
//     .then((bugsnag) => {
//       Bugsnag = bugsnag.default;
//       bugsnag.default.start({
//         appVersion: process.env.APP_VERSION,
//         appType: process.env.APP_TYPE,
//         apiKey: process.env.BUGSNAG_KEY,
//         onError: (event) => {
//           event.addMetadata('state', getState());
//           event.errors[0].stacktrace = event.errors[0].stacktrace.map(
//             (frame) => {
//               frame.file = frame.file.replace(
//                 /chrome-extension:/g,
//                 'chrome_extension:'
//               );
//               return frame;
//             }
//           );
//         },
//       });

//       if (bugsnagList.length) {
//         bugsnagList.forEach((args) => (Bugsnag || BugsnagFallback).notify(args));
//       }
//     })
//     .catch((err) => {
//       console.error('Bugsnag import', err);
//     });
// }

interface Props {
  children?: JSX.Element,
  message?: string,
  name?: string,
}

interface State {
  hasError: boolean,
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    console.error('getDerivedStateFromError', error);
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    // You can also log the error to an error reporting service
    // Bugsnag.notify(error, (event) => {
    //   event.addMetadata('details', { source: 'Error boundary', name: this.props.name });
    // });
    console.error("Error caught:", error);
  }

  render(): JSX.Element {
    const { message } = this.props;
    if (this.state.hasError) {
      return message ? <h1>{message}</h1> : null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
